module.exports = __webpack_public_path__ + "img/ico_default.19f74dd2.png";